export class BaseDataTransferObject {
    public id!: number;
}
